import React from "react";
const CampaignGridContext = React.createContext();
export default CampaignGridContext;